module.exports = __webpack_public_path__ + "static/sample_OLIVE_PC-6b8c4e3e351f95063f311b5af5f2cd46.png";